module.exports = __webpack_public_path__ + "static/media/shareLockGuide2.c76aa668.png";